import React from 'react';
import { CommonPropTypes } from '../Icons.types';
const ArrowShort: React.FC<CommonPropTypes> = ({
  className
}) => {
  return <svg className={className} width='4' height='5' viewBox='0 0 4 5' fill='none' xmlns='http://www.w3.org/2000/svg' data-sentry-element="svg" data-sentry-component="ArrowShort" data-sentry-source-file="Dot.tsx">
      <circle cx='2' cy='2.5' r='2' fill='#494949' data-sentry-element="circle" data-sentry-source-file="Dot.tsx" />
    </svg>;
};
export default ArrowShort;